export var storeName = 'appShell';
export var appShellInitialState = {
    cmsBannerData: null,
    stateBannerData: null,
    AppFlowCode: {},
    analytics: {},
    analyticsEvent: {},
    baseURL: undefined,
    baseURLBB: {
        url: '',
    },
    baseURLDTV: {
        url: '',
    },
    baseURLDTVS: {
        url: '',
    },
    baseURLWLS: {
        url: '',
    },
    catalogResponse: undefined,
    'csrf-token': {},
    isTopPanelLoadedAlready: {},
    offerId: {
        offer: '',
    },
    pbData: {
        dueMonthly: 0,
        dueOneTime: 0,
        dueToday: 0,
        readyToCheckout: false,
    },
    priceBarUpdate: {
        dueMonthly: 0,
        dueOneTime: 0,
        dueToday: 0,
        readyToCheckout: false,
    },
    profile: {},
    submitOrder: {
        orderSubmitted: false,
    },
    submitOrderError: {
        orderSubmitError: false,
    },
};
//# sourceMappingURL=app-shell.model.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/models/app-shell.model.js
// module id = 1423
// module chunks = 8